<template>
	<VDataGridV2
		sticky
		:loader="loader"
		:context-menu="TransportZonesService.contextMenu"
		paginated
		show-action-bar
		@row:dblclick="openCard"
	>
		<VDataGridColumnV2
			id="id"
			width="50px"
			content-align="center"
			label="№"
		>
			<template #default="{ row }">
				<VLink
					@click="openCard"
				>
					{{ row.id }}
				</VLink>
				<VBadge
					v-if="row.isDeleted"
					class="warning"
				>
					Удалён
				</VBadge>
			</template>
		</VDataGridColumnV2>

		<VDataGridColumnV2
			id="name"
			width="500px"
			label="Наименование"
			content-class="ellipsis"
			filterable
      :filter-props="{
        placeholder: 'Введите наименование зоны',
        clearable: true,
      }"
			filter-send-name="pattern"
		>
			<template #default="{ row }">
				{{ row.name }}
			</template>
		</VDataGridColumnV2>

		<VDataGridActionBarV2>
			<VButton
				theme="primary"
				@click="openCard()"
			>
				Создать новую зону
			</VButton>
		</VDataGridActionBarV2>
	</VDataGridV2>
</template>

<script lang="ts">

import DataGridLoader        from '@/lib/components/VDataGridV2/DataGridLoader';
import TransportZone         from '@/domains/TransportZones/TransportZone';
import TransportZonesService from '@/domains/TransportZones/TransportZonesService';
import UnitsService from "@/domains/Units/UnitsService";

export default defineComponent({
	name: 'TransportZonesRegistry',

	data() {
		return {
			TransportZonesService,

			loader: new DataGridLoader(TransportZonesService.getListPaginated),
		};
	},

	methods: {
		reload() {
			this.loader.refresh();
		},

		async openCard(row?: TransportZone) {
      if (await TransportZonesService.showTransportZoneCard(row)) {
        this.loader.refresh();
      }
		},
	},
});
</script>
